export default __webpack_public_path__ + "static/media/CO2_avoided.62eee97e.svg";